import { PrivacyPolicyUrl } from './privacy-policy-url';
import { PrivacyPolicyVersion } from './privacy-policy-version';

interface Params {
  version: PrivacyPolicyVersion;
  url: PrivacyPolicyUrl;
}

export class PrivacyPolicyAggregate {
  readonly version: PrivacyPolicyVersion;
  readonly url: PrivacyPolicyUrl;
  constructor(private readonly params?: Params) {
    if (params) {
      this.version = params.version;
      this.url = params.url;
    } else {
      this.version = new PrivacyPolicyVersion();
      this.url = new PrivacyPolicyUrl('https://www.toretanow.app');
    }
  }
}
